import { gql } from "apollo-boost"

export default gql`
  mutation UpdateShoppingCartCheckOut(
    $orderId: ID!
    $orderDetailInputs: [UpdateShoppingCartInput!]
  ) {
    updateShoppingCart(
      orderId: $orderId
      orderDetailInputs: $orderDetailInputs
    ) {
      id
      unitPrice
      quantity
    }
  }
`
